import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function EnterpriseGroupBuyOrderRedirect() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!!searchParams && !!searchParams?.get('enterpriseGroupBuyId')) {
      navigate(`/enterpriseGroupBuy/${searchParams.get('enterpriseGroupBuyId')}`);
    }
  }, [searchParams]);

  return <></>;
}
